var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload" },
    [
      _vm._t("required"),
      _vm._v(" "),
      _vm._t(
        "errors",
        [
          _vm.limit || _vm.size || _vm.typeError
            ? _c("div", { staticClass: "upload__errors" }, [
                _vm.limit
                  ? _c("span", { staticClass: "upload__error" }, [
                      _vm._v(
                        _vm._s(
                          _vm._(
                            "Exceeded the maximum number of files to upload"
                          )
                        )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.size
                  ? _c("span", { staticClass: "upload__error" }, [
                      _vm._v(
                        _vm._s(
                          _vm._("Exceeded the maximum file weight for download")
                        )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.typeError
                  ? _c("span", { staticClass: "upload__error" }, [
                      _vm._v(_vm._s(_vm._("Unsupported file format")))
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ],
        { limit: _vm.limit, size: _vm.size, typeError: _vm.typeError }
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "upload__wrapper",
          class: { disabled: _vm.files.length == _vm.maxFiles }
        },
        [
          _c(
            "label",
            { staticClass: "label", attrs: { for: _vm.id } },
            [
              _vm._t("button", [
                _c("div", { staticClass: "upload__button" }, [
                  _c("span", [_vm._v(_vm._s(_vm.buttonText))])
                ])
              ]),
              _vm._v(" "),
              _vm.multipleFiles == true
                ? _c("input", {
                    staticClass: "upload__input",
                    attrs: {
                      type: "file",
                      id: _vm.id,
                      multiple: "multiple",
                      accept: _vm.acceptedFilesReplaced
                    },
                    on: { change: _vm.onFileChange }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.multipleFiles == false
                ? _c("input", {
                    staticClass: "upload__input",
                    attrs: {
                      type: "file",
                      id: _vm.id,
                      accept: _vm.acceptedFilesReplaced
                    },
                    on: { change: _vm.onFileChange }
                  })
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "upload__message" },
        [
          _c("div", { staticClass: "upload__title" }, [
            _vm._v(_vm._s(_vm._("Requirements for downloaded files ")))
          ]),
          _vm._v(" "),
          _vm._t(
            "info",
            [
              _c("div", { staticClass: "upload__info" }, [
                _c("span", [
                  _vm._v(
                    "(" +
                      _vm._s(_vm._("Maximum number of files - ")) +
                      " " +
                      _vm._s(_vm.maxFiles) +
                      ", "
                  )
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm._("maximum file size - ")) +
                      " " +
                      _vm._s(_vm.maxSize) +
                      " " +
                      _vm._s(_vm._("MB")) +
                      ", "
                  )
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm._("allowed formats - ")) +
                      " " +
                      _vm._s(_vm.acceptedFiles) +
                      ")"
                  )
                ])
              ])
            ],
            {
              maxFiles: _vm.maxFiles,
              maxSize: _vm.maxSize,
              acceptedFiles: _vm.acceptedFiles
            }
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm.files.length > 0
        ? _c(
            "div",
            { staticClass: "upload-list" },
            _vm._l(_vm.files, function(file, index) {
              return _c(
                "div",
                {
                  staticClass: "upload-list__item",
                  class: {
                    "upload-list__item--doc": !_vm.checkOnImageFile(file)
                  }
                },
                [
                  _vm.checkOnImageFile(file)
                    ? _c(
                        "div",
                        [
                          _c(
                            "div",
                            { staticClass: "upload-list__file-wrapper" },
                            [
                              _c("img", {
                                staticClass: "upload-list__file",
                                attrs: { src: file, alt: "" }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _vm._t(
                            "filesName",
                            [_c("p", [_vm._v(_vm._s(_vm.filesName[index]))])],
                            { filesName: _vm.filesName, index: index }
                          )
                        ],
                        2
                      )
                    : _c("div", { staticClass: "upload-list__tag" }, [
                        _vm._v(_vm._s(_vm.filesName[index]))
                      ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "upload-list__remove",
                      class: {
                        "upload-list__remove--doc": !_vm.checkOnImageFile(file)
                      },
                      on: {
                        click: function($event) {
                          return _vm.removeFile(index)
                        }
                      }
                    },
                    [_vm._t("remove", [_c("i", [_vm._v("x")])])],
                    2
                  )
                ]
              )
            }),
            0
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72323a73", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72323a73","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Uploader/Uploader.vue
// module id = 991
// module chunks = 0